import '/src/components/burger-menu/burger-menu';
import '/src/components/modal/modal';
import '/src/components/form/form';
import '/src/components/accordion/accordion';
import '/src/pages/home/views/reviews/reviews-swiper';
